// Actions
import {
  SET_USA,
  SET_INTERNATIONAL,
  SET_GEOGRAPHY_STATE
} from "../actionTypes/geography.actionTypes";

// Classes
import { GeographyReducerState } from "../classes/geography.classes";

const initialState = new GeographyReducerState();

export const GeographyReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_USA:
      return { ...state, usa: action.payload };
    case SET_INTERNATIONAL:
      return { ...state, international: action.payload };
    case SET_GEOGRAPHY_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
